// extracted by mini-css-extract-plugin
export default {"container":"Calculator_container__FC3y8","calculator":"Calculator_calculator__pRjQP","disclaimer":"Calculator_disclaimer__5lj+P","bottomDiv":"Calculator_bottomDiv__B7t2W"};